import HttpWrapper from '@utils/http/httpWrapper'
import ShipbobAppSettings from '../../appSettings/appSetting'
import toastr from 'toastr'

export const MERCHANT_PRICING_API = ShipbobAppSettings.MerchantPricingApi.ApiBaseUrl

class LocationsServiceInternal {
  urls () {
    return {
      getAllCountryCurrency: MERCHANT_PRICING_API + 'locations/allcountries'
    }
  }

  handleGetAllCountryCurrency (res) {
    return toastr.error('Unable to retrieve countries and their currencies')
  }

  async getAllCountryCurrency () {
    const request = {
      Url: this.urls().getAllCountryCurrency
    }
    return await HttpWrapper.Get(request, undefined, this.handleGetAllCountryCurrency, true)
  }
}

export const LocationsService = new LocationsServiceInternal()
